/*
 * @Author: your name
 * @Date: 2020-10-10 11:34:26
 * @LastEditTime: 2020-10-21 18:55:46
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \A100\src\main.js
 */

import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import axios from 'axios'
import 'vant/lib/index.css'
import { CountDown } from 'vant'
import '../src/assets/styles/font.css'
import fastClick from 'fastclick'
import infiniteScroll from 'vue-infinite-scroll'
import { setLocalStorage } from '@/utils/localStorage'

// 引入过渡动画样式
import './assets/styles/transition.less'

Vue.prototype.$axios = axios
// 解决苹果手机input框要双击才能选中的bug
// import FastClick from 'fastclick'
// const str = navigator.userAgent.toLowerCase()
// const ver = str.match(/cpu iphone os (.*?) like mac os/)
// if (!ver) {
//   //非IOS系统
//   // 引入fastclick 做相关处理
//   FastClick.attach(document.body)
// } else {
//   if (parseInt(ver[1]) < 11) {
//     // 引入fastclick 做相关处理
//     FastClick.attach(document.body)
//   }
// }

// FastClick.prototype.focus = function(targetElement) {
//   let length
//   if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
//     length = targetElement.value.length
//     targetElement.focus()
//     targetElement.setSelectionRange(length, length)
//   } else {
//     targetElement.focus()
//   }
// }
// // 解决苹果手机input框要双击才能选中的bug

// vue音频组件
import VueAudio from 'vue-audio-better'
Vue.use(VueAudio)
// vue音频组件

// vue视频组件
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)
// vue视频组件

Vue.use(Vant)
Vue.use(infiniteScroll)
Vue.use(CountDown)
// fastClick.attach(document.body)

// 判断运行环境并存储到localStorage中
// 判断运行环境（安卓, ios, 微信）
let u = navigator.userAgent
let ua = window.navigator.userAgent.toLowerCase()
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
if (isAndroid) {
  setLocalStorage('environment', 'android')
} else if (isIOS) {
  setLocalStorage('environment', 'ios')
}
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
  if (ua.indexOf('iphone') > -1) {
    setLocalStorage('environment', 'ios-weixin')
  } else if (ua.indexOf('android') > -1) {
    setLocalStorage('environment', 'android-weixin')
  } else {
    setLocalStorage('environment', 'weixin')
  }
} else {
  // console.log('非微信')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js